import { Box, Card, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import { customPalette } from '../../themes/customTheme';

export const SummaryScore = ({ data }) => {
  const t = useTranslate();

  return (
    <Card
      elevation={0}
      sx={{
        background: '#fff',
        color: '#000',
        padding: '24px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      <Typography fontSize={26} fontWeight="600" sx={{ marginBottom: '16px' }}>
        {t('resources.score.list.summaryScore_title')}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ marginRight: '96px' }}>
          <Typography
            fontSize={24}
            fontWeight="700"
            sx={{ color: customPalette.primary.main }}
          >
            {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
              data?.total_points || 0
            )}
          </Typography>
          <Typography fontSize={16} fontWeight="400">
            {t('resources.score.list.fields.accumulated')}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Box>
            <Typography fontSize={18} fontWeight="700">
              {Intl.NumberFormat('es-AR', {
                maximumFractionDigits: 2,
              }).format(data?.accumulated_points || 0)}
            </Typography>
            <Typography fontSize={16} fontWeight="400">
              {t('resources.score.list.fields.total')}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
